import React, { useCallback, useContext } from "react";
import { useInterceptor } from "./InterceptorProvider";

const KPIContext = React.createContext({
    getKPIByNodeId: async () => {},
    addKPI: async data => {},
    editKPI: async (id, data) => {},
    deleteKPI: async id => {},
    getKPIMetricRecords: async () => {},
    editKPIMetricRecords: async (id, data) => {}
});

export const KPIProvider = ({ children }) => {
    const { api } = useInterceptor();

    const getKPIByNodeId = useCallback(
        async nodeId => {
            try {
                const response = await api.get(`/kpi/node-id/${nodeId}`);

                return response.data;
            } catch (err) {
                console.log(err);
                return err.response?.message;
            }
        },
        [api]
    );

    const addKPI = useCallback(
        async data => {
            try {
                const response = await api.post("/kpi", data);

                return response.data;
            } catch (err) {
                console.log(err);
                return err.response?.message;
            }
        },
        [api]
    );

    const editKPI = useCallback(
        async (id, data) => {
            try {
                const response = await api.put(`/kpi/${id}`, data);

                return response.data;
            } catch (err) {
                console.log(err);
                return err.response?.message;
            }
        },
        [api]
    );

    const deleteKPI = useCallback(
        async id => {
            try {
                const response = await api.delete(`/kpi/${id}`);

                return response.data;
            } catch (err) {
                console.log(err);
                return err.response?.message;
            }
        },
        [api]
    );

    const getKPIMetricRecords = useCallback(
        async nodeId => {
            try {
                const response = await api.get(`/kpi/data/node-id/${nodeId}`);

                return response.data;
            } catch (err) {
                console.log(err);
                return err.response?.message;
            }
        },
        [api]
    );

    const editKPIMetricRecords = useCallback(
        async (kpiId, data) => {
            try {
                const response = await api.put(`/kpi/data/kpi-id/${kpiId}`, data);

                return response.data;
            } catch (err) {
                console.log(err);
                return err.response?.message;
            }
        },
        [api]
    );

    return (
        <KPIContext.Provider
            value={{
                getKPIByNodeId,
                addKPI,
                editKPI,
                deleteKPI,
                getKPIMetricRecords,
                editKPIMetricRecords
            }}
        >
            {children}
        </KPIContext.Provider>
    );
};

export function useKPI() {
    const kpiContext = useContext(KPIContext);

    return kpiContext;
}
